/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GetMenuOrdersOwnSort = {
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
} as const;
export type GetMenuOrdersOwnSort = typeof GetMenuOrdersOwnSort[keyof typeof GetMenuOrdersOwnSort];


export function instanceOfGetMenuOrdersOwnSort(value: any): boolean {
    for (const key in GetMenuOrdersOwnSort) {
        if (Object.prototype.hasOwnProperty.call(GetMenuOrdersOwnSort, key)) {
            if (GetMenuOrdersOwnSort[key as keyof typeof GetMenuOrdersOwnSort] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GetMenuOrdersOwnSortFromJSON(json: any): GetMenuOrdersOwnSort {
    return GetMenuOrdersOwnSortFromJSONTyped(json, false);
}

export function GetMenuOrdersOwnSortFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuOrdersOwnSort {
    return json as GetMenuOrdersOwnSort;
}

export function GetMenuOrdersOwnSortToJSON(value?: GetMenuOrdersOwnSort | null): any {
    return value as any;
}

export function GetMenuOrdersOwnSortToJSONTyped(value: any, ignoreDiscriminator: boolean): GetMenuOrdersOwnSort {
    return value as GetMenuOrdersOwnSort;
}

